import AxiosClient from '../../../../services/axios.services';

class DashboardSelecContratacionesServices {
  getDashboarSelecContrataciones = params => AxiosClient.get('/api/app/seleccion_contratacion_dashboard_motivo_solicitud/', {
    headers: {'Content-Type': 'application/json'},
    params: params
  });
}

export default new DashboardSelecContratacionesServices();

//seleccion_contratacion_dashboard_motivo_solicitud
//seleccion_contratacion_dashboard_contrataciones
//seleccion_contratacion_dashboard_vacantes